export default __webpack_public_path__ + "5ed0ded25704b007e96541281cc6b840.jpg";